import defaultPlaceholder from "@/assets/images/default-placeholder.svg";

/** 商品／文章／團隊成員等任何缺少圖片時使用的預設圖片，統一用這個常數，之後要換圖只要改這裡一個地方。 */
export const DEFAULT_IMAGE_URL = defaultPlaceholder;

/** 取得圖片網址；沒有值（null/undefined/空字串）時 fallback 成預設圖片，避免畫面出現破圖或空白區塊。 */
export function withImageFallback(url?: string | null): string {
  return url && url.trim() !== "" ? url : DEFAULT_IMAGE_URL;
}
